<!-- 溯源记录 -->
<template>
    <div class="container">
        <Button class="theme-bc theme-default-color mb24 mr24" icon="md-add-circle" @click="goRecord">新增记录</Button>
        <Button class="theme-bc theme-default-color mb24" @click="goManage">模块管理</Button>
        <Table ref="selection" :columns="columnsTable" :data="dataTable" border @on-selection-change="changeSelection">
            <!-- 记录模块 -->
            <template slot-scope="{ row }" slot="example_module_count">
                <Button @click="goModule(row)">{{row.example_module_count}}</Button>
            </template>
            <!-- 关联绑定 -->
            <template slot-scope="{ row }" slot="product_count">
                <Button @click="goBind(row)">{{row.product_count*1 + row.batch_count*1}}</Button>
            </template>
            <template slot-scope="{ row }" slot="operate">
                <div class="flex-sa">
                    <Button type="primary" ghost @click="goRecord(row)">编辑</Button>
                    <Button type="error" ghost @click="goDel(1, row)">删除</Button>
                </div>
            </template>
        </Table>
        <div class="page-checkbox-container">
            <div class="ml24">
                <Checkbox v-model="del_value" @on-change="handleSelectAll"> 
                    <span class="mr24 ml24">全选</span>
                </Checkbox>
                <span class="mr24">已经选择{{delData.length}}个</span>
                <Button type="error" ghost @click="goDel(0)">删除</Button>
            </div>
            <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"/>
        </div>
        <!-- 模块管理 -->
        <Drawer v-model="manageModal" title="模块管理" width="60" :closable="false">
            <div>
                <Input class="w200 mr24 mb24" type="text" v-model="pageManage.keywords" clearable placeholder="搜索模块、节点"></Input>
                <Button class="theme-bc theme-default-color mb24" icon="ios-search" @click="goSearch(1)">确认搜索</Button>
            </div>
            <Button class="theme-bc theme-default-color mb12" icon="md-add-circle" @click="goEditManage">新增模块</Button>
            <Table :columns="columnManage" :data="dataManage" border>
                <!-- 节点 -->
                <template slot-scope="{ row }" slot="node_count">
                    <Button @click="goNode(1, row)">{{row.node_count}}</Button>
                    <!-- <Button type="dashed">{{row.node_count}}</Button> -->
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <div class="flex-sa">
                        <Button type="primary" ghost @click="goEditManage(row)">编辑</Button>
                        <Button type="error" ghost @click="goDelete(row)">删除</Button>
                    </div>
                </template>
            </Table>
            <Page class="page-container" :current="pageManage.page" :page-size="pageManage.limit" :total="totalManage" show-elevator show-total @on-change="changePageManage"/>
            <div slot="footer"></div>
        </Drawer>
        <!-- 记录模块 -->
        <Drawer v-model="moduleModal" title="记录模块" width="60" :closable="false">
            <div>
                <Input class="w200 mr24 mb24" type="text" v-model="pageModule.keywords" clearable placeholder="搜索模块、节点"></Input>
                <Button class="theme-bc theme-default-color mb24" icon="ios-search" @click="goSearch(2)">确认搜索</Button>
            </div>
            <Button class="theme-bc theme-default-color mb12" icon="md-add-circle" @click="goEditModule">新增记录模块</Button>
            <span class="module-tip">鼠标放置序号前的图标，上下拖拽，可调整记录模块的顺序。</span>
            <Table :columns="columnModule" :data="dataModule" border draggable @on-drag-drop="handleDragDrop">
                <template slot-scope="{ index }" slot="id">
                    <div class="flex-sb">
                        <img src="@/assets/instance/sort.png" alt="" class="icon-sort">
                        {{ index + 1 }}
                    </div>
                </template>
                <!-- 节点 -->
                <template slot-scope="{ row }" slot="node_count">
                    <Button @click="goNode(2, row)">{{row.node_count}}</Button>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <Button type="error" ghost @click="goDel(2, row)">删除</Button>
                </template>
            </Table>
            <div slot="footer"></div>
        </Drawer>
        <!-- 节点 -->
        <Modal v-model="nodeModal" title="节点" width="50" :mask-closable="false">
            <Button class="theme-bc mb24 theme-default-color" icon="md-add-circle" @click="goEditNode">新增节点</Button>
            <Table :columns="columnNode" :data="dataNode" border>
                <template slot-scope="{ row }" slot="operate">
                    <div class="flex-sa">
                        <Button type="primary" ghost @click="goEditNode(row)">编辑</Button>
                        <Button type="error" ghost @click="goDel(3, row)">删除</Button>
                    </div>
                </template>
            </Table>
            <Page class="page-container" :current="pageNode.page" :page-size="pageNode.limit" :total="totalNode" show-elevator show-total @on-change="changePageNode"/>
            <div slot="footer"></div>
        </Modal>
        <!-- 关联绑定 -->
        <Modal v-model="bindModal" width="50">
            <Menu mode="horizontal" :active-name="menuID" @on-select="selectMenu">
                <MenuItem name="1">关联产品</MenuItem>
                <MenuItem name="2">关联批次</MenuItem>
            </Menu>
            <!-- 关联产品 -->
            <template v-if="menuID == 1">
                <Button class="theme-bc theme-default-color mt24 mb24" icon="md-add-circle" @click="goProduct">新增关联产品</Button>
                <Table :columns="columnProduct" :data="dataProduct" border>
                    <!-- 产品名称 -->
                    <template slot-scope="{ row }" slot="product">
                        <div>{{row.product ? row.product.product_name : ""}}</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <Button type="error" ghost @click="goDel(4, row)">删除</Button>
                    </template>
                </Table>
                <Page class="page-container" :current="pageProduct.page" :page-size="pageProduct.limit" :total="totalProduct" show-elevator show-total @on-change="changePageProduct"/>
            </template>
            <!-- 关联批次 -->
            <template v-else-if="menuID == 2">
                <Button class="theme-bc theme-default-color mt24 mb24" icon="md-add-circle" @click="goBatch">新增关联批次</Button>
                <Table :columns="columnBatch" :data="dataBatch" border>
                    <!-- 批次名称 -->
                    <template slot-scope="{ row }" slot="batch">
                        <div>{{row.batch ? row.batch.batch_name : ""}}</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <Button type="error" ghost @click="goDel(5, row)">删除</Button>
                    </template>
                </Table>
                <Page class="page-container" :current="pageBatch.page" :page-size="pageBatch.limit" :total="totalBatch" show-elevator show-total @on-change="changePageBatch"/>
            </template>
            <div slot="footer"></div>
        </Modal>
        <!-- 编辑记录/新增记录 -->
        <Modal v-model="recordModal" :title="recordTitle" width="30" :mask-closable="false">
            <Form :model="formRecord" label-position="right" :label-width="100">
                <FormItem label="实例名称：">
                    <Input type="text" v-model="formRecord.name" placeholder="请输入实例名称"></Input>
                </FormItem>
                <FormItem label="备注：">
                    <Input type="text" v-model="formRecord.remarks" placeholder="请输入备注信息"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelRecordModal">取消</Button>
                <Button class="theme-bc theme-default-color" @click="submitRecordModal">确认</Button>
            </div>
        </Modal>
        <!-- 新增模块/编辑模块 -->
        <Modal v-model="editManageModal" :title="editManageTitle" width="30" :mask-closable="false">
            <Form :model="formManage" label-position="right" :label-width="100">
                <FormItem label="模块名称：">
                    <Input type="text" v-model="formManage.name" placeholder="请输入模块名称"></Input>
                    <div v-for="(item, index) of formManage.node" :key="index" class="manage-container">
                        <Input type="text" v-model="item.name" placeholder="请输入节点名称"></Input>
                        <img src="@/assets/delete.png" alt="" class="manage-delete" @click="deleteManage(item, index)">
                    </div>
                    <Button class="theme-bc theme-default-color mt12 ml24" icon="md-add-circle" @click="addManage">添加节点名称</Button>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelEditManageModal">取消</Button>
                <Button class="theme-bc theme-default-color" @click="submitEditManageModal">确认</Button>
            </div>
        </Modal>
        <!-- 新增记录模块 -->
        <Modal v-model="editModuleModal" title="新增记录模块" width="30" :mask-closable="false">
            <Form :model="formModule" label-position="right" :label-width="100">
                <FormItem label="模块名称：">
                    <Select v-model="formModule.module_id" clearable filterable placeholder="请输入模块名称" @on-change="changeModule">
                        <Option v-for="item in moduleList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                <template v-if="formModule.module_id">
                    <FormItem label="节点名称：">
                        <Select v-model="formModule.node_id" clearable filterable placeholder="请输入节点名称">
                            <Option v-for="item in nodeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="节点内容：">
                        <Input type="textarea" v-model="formModule.content" placeholder="请输入节点内容"></Input>
                    </FormItem>
                    <FormItem label="图片：">
                        <div class="picture-container">
                            <div class="upload-container mb24" @click="openModal(0, 1)">
                                <Icon type="ios-add" size="40" color="#AEAEB3"/>
                            </div>
                            <draggable
                                class="dragg-container"
                                v-model="show_imgs"
                                chosen-class="chosen"
                                force-fallback="true"
                                group="people"
                                animation="500"
                                :handle="'.dragg'"
                                @start="onStart"
                                @end="onEnd"
                                >
                                    <div v-for="(item, index) in show_imgs" :key="index">
                                        <div class="upload-container mr24 mb24 position-r dragg">
                                            <Icon class="upload-icon" size="20" type="ios-close-circle" color="#f00" @click="delImg(index)"/>
                                            <img class="wh100" :src="item">
                                        </div>
                                    </div>
                            </draggable>
                        </div>
                    </FormItem>
                    <FormItem label="视频：">
                        <div class="upload-container mb24" @click="openModal(2, 2)">
                            <video class="wh100" v-if="formModule.video" :src="show_video"></video>
                            <Icon v-else type="ios-add" size="40" color="#AEAEB3"/>
                        </div>
                    </FormItem>
                    <FormItem label="地址：">
                        <Input type="text" v-model="formModule.address" placeholder="请输入地址信息"></Input>
                    </FormItem>
                    <FormItem label="时间：">
                        <DatePicker class="width_100" :value="formModule.node_time" type="datetime" placeholder="请选择时间" @on-change="changeModuleTime"></DatePicker>
                    </FormItem>
                    <FormItem label="排列序号：">
                        <Input type="text" v-model="formModule.sort" placeholder="请输入排列序号"></Input>
                    </FormItem>
                </template>
            </Form>
            <div slot="footer">
                <Button @click="cancelEditModuleModal">取消</Button>
                <Button class="theme-bc theme-default-color" @click="submitEditModuleModal">确认</Button>
            </div>
        </Modal>
        <!-- 新增关联产品 -->
        <Modal v-model="productModal" title="新增关联产品" width="30" :mask-closable="false">
            <Form :model="formProduct" label-position="right" :label-width="100">
                <FormItem label="选择产品：">
                    <Select v-model="formProduct.product_id" clearable filterable placeholder="请选择产品">
                        <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.product_name }}</Option>
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelProductModal">取消</Button>
                <Button class="theme-bc theme-default-color" @click="submitProductModal">确认</Button>
            </div>
        </Modal>
        <!-- 新增关联批次 -->
        <Modal v-model="batchModal" title="新增关联批次" width="30" :mask-closable="false">
            <Form :model="formBatch" label-position="right" :label-width="100">
                <FormItem label="关联批次：">
                    <Select v-model="formBatch.batch_id" clearable filterable placeholder="请选择批次">
                        <Option v-for="item in batchList" :value="item.id" :key="item.id">{{ item.batch_name }}</Option>
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelBatchModal">取消</Button>
                <Button class="theme-bc theme-default-color" @click="submitBatchModal">确认</Button>
            </div>
        </Modal>
        <!-- 模块管理里面的编辑节点/新增节点 -->
        <Modal v-model="editNodeManageModal" :title="editNodeTitle" width="30" :mask-closable="false">
            <Form :model="formNodeManage" label-position="right" :label-width="100">
                <FormItem label="节点名称：">
                    <Input type="text" v-model="formNodeManage.name" placeholder="请输入节点名称"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelEditNodeManageModal">取消</Button>
                <Button class="theme-bc theme-default-color" @click="submitEditNodeModal">确认</Button>
            </div>
        </Modal>
        <!-- 编辑节点/新增节点 -->
        <Modal v-model="editNodeModal" :title="editNodeTitle" width="30" :mask-closable="false">
            <Form :model="formNode" label-position="right" :label-width="100">
                <FormItem label="节点名称：">
                    <Select v-model="formNode.node_id" :disabled="edit_node_value" clearable filterable placeholder="请输入节点名称">
                        <Option v-for="item in nodeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="节点内容：">
                    <Input type="textarea" v-model="formNode.content" placeholder="请输入节点内容"></Input>
                </FormItem>
                <FormItem label="图片：">
                    <div class="picture-container">
                        <div class="upload-container mb24" @click="openModal(0, 1)">
                            <Icon type="ios-add" size="40" color="#AEAEB3"/>
                        </div>
                        <draggable
                            class="dragg-container"
                            v-model="show_imgs"
                            chosen-class="chosen"
                            force-fallback="true"
                            group="people"
                            animation="500"
                            :handle="'.dragg'"
                            @start="onStart"
                            @end="onEnd"
                            >
                                <div v-for="(item, index) in show_imgs" :key="index">
                                    <div class="upload-container mr24 mb24 position-r dragg">
                                        <Icon class="upload-icon" size="20" type="ios-close-circle" color="#f00" @click="delImg(index)"/>
                                        <img class="wh100" :src="item">
                                    </div>
                                </div>
                        </draggable>
                    </div>
                </FormItem>
                <FormItem label="视频：">
                    <div class="upload-container mb24" @click="openModal(2, 2)">
                        <video class="wh100" v-if="formNode.video" :src="show_video"></video>
                        <Icon v-else type="ios-add" size="40" color="#AEAEB3"/>
                    </div>
                </FormItem>
                <FormItem label="地址：">
                    <Input type="text" v-model="formNode.address" placeholder="请输入地址信息"></Input>
                </FormItem>
                <FormItem label="时间：">
                    <DatePicker class="width_100" :value="formNode.node_time" type="datetime" placeholder="请选择时间" @on-change="changeNodeTime"></DatePicker>
                </FormItem>
                <FormItem label="排列序号：">
                    <Input type="text" v-model="formNode.sort" placeholder="请输入排列序号"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelEditNodeModal">取消</Button>
                <Button class="theme-bc theme-default-color" @click="submitEditNodeModal">确认</Button>
            </div>
        </Modal>
        <!-- 删除 -->
        <Modal v-model="deleteModal">
            <p slot="header"><span class="delete-modal-title">提示</span></p>
            <div class="delete-modal-container">
                <div class="flex-c">
                    <Icon type="md-alert" color="#FF761D" size="32" class="mr24"/>
                    <div>是否确认删除 {{delete_key}}模块<br/>删除后将无法恢复！</div>
                </div>
                <div class="delete-modal-footer">将会删除溯源记录相关联的数据</div>
            </div>
            <div slot="footer">
                <Button @click="cancelDeleteModal">取消</Button>
                <Button class="theme-bc theme-default-color" @click="submitDeleteModal">确认删除</Button>
            </div>
        </Modal>
        <pictureLibrary v-if="switch_modal" :switch_modal.sync="switch_modal" :select="imgtype" :select_type='select_type' @change="costPlannedAmountChange"></pictureLibrary>
    </div>
</template>

<script>
import {
    example_list, example_save, example_delete, example_module_list, example_module_delete, example_node_list, example_node_save, 
    example_node_info, example_node_delete, example_product_list, example_batch_list, example_product_save, example_batch_save,example_product_delete, 
    example_batch_delete, example_module_sort, example_node_sort, module_list, module_save, module_del, module_node_select, module_node_del, product_select, 
    batch_select, module_select, module_node, module_node_save
} from '@/api/index';
import draggable from "vuedraggable";
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
export default {
    components: { draggable, pictureLibrary },
    data() {
        return {
            select_type: 'image',
            srctype: "",
            imgtype: 1,
            switch_modal: false,
            example_id: "",
            module_id: "",
            example_module_id: "", // 记录模块列表id
            menuID: "1",
            itemData: { 
                useValue: false,
            },
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnsTable: [
                { type: 'selection', width: 60, align: 'center' },
                { type: 'index', width: 60, align: 'center' },
                { title: "记录名称", key: "name", align: "center" },
                { title: "备注", key: "remarks", align: "center" },
                { title: "记录模块", slot: "example_module_count", align: "center" },
                { title: "关联绑定", slot: "product_count", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "200px" },
            ],
            dataTable: [],
            manageModal: false,
            moduleModal: false,
            nodeModal: false,
            bindModal: false,
            editNodeModal: false,
            editNodeManageModal: false,
            edit_node_value: false,
            editNodeTitle: "",
            pageModule: {
                example_id: "",
                keywords: "",
            },
            columnManage: [
                { type: 'index', width: 60, align: 'center' },
                { title: "模块名称", key: "name", align: "center" },
                { title: "节点", slot: "node_count", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "200px" },
            ],
            dataManage: [],
            pageManage: {
                page: 1,
                limit: 10,
                keywords: "",
            },
            totalManage: 0,
            columnModule: [
                { title: "#", slot: "id", align: "right", width: "100px" },
                { title: "记录模块名称", key: "name", align: "center" },
                { title: "节点", slot: "node_count", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "100px" },
            ],
            dataModule: [],
            pageNode: {
                page: 1,
                limit: 10,
                example_module_id: "",
            },
            totalNode: 0,
            columnNode: [
                { type: 'index', width: 60, align: 'center' },
                { title: "排列序号", key: "sort", align: "center" },
                { title: "节点名称", key: "name", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "200px" },
            ],
            dataNode: [],
            pageProduct: {
                page: 1,
                limit: 10,
                example_id: "",
            },
            totalProduct: 0,
            columnProduct: [
                { type: 'index', width: 60, align: 'center' },
                { title: "产品名称", slot: "product", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "100px" },
            ],
            dataProduct: [],
            pageBatch: {
                page: 1,
                limit: 10,
                example_id: "",
            },
            totalBatch: 0,
            columnBatch: [
                { type: 'index', width: 60, align: 'center' },
                { title: "批次名称", slot: "batch", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "100px" },
            ],
            dataBatch: [],
            nameList: [],
            formData: { name: "" },
            formRecord: {
                id: "",
                name: "",
                remarks: "",
            },
            formManage: {
                id: "",
                name: "",
                node: [],
            },
            formModule: {
                example_node_id: "",
                module_id: "",
                content: "",
                imgs: "",
                video: "",
                address: "",
                node_time: "",
                sort: "",
                example_id: "",
                node_id: "",
            },
            formNode: {
                example_node_id: "",
                module_id: "",
                content: "",
                imgs: "",
                video: "",
                address: "",
                node_time: this.getCurrentTime(),
                sort: "",
                example_id: "",
                node_id: "",
            },
            formNodeManage: {
                name: "",
                id: "",
                module_id: "",
            },
            formProduct: {
                product_id: "",
                example_id: "",
            },
            formBatch: {
                batch_id: "",
                example_id: "",
            },
            imgs: [],
            show_imgs: [],
            show_video: "",
            recordModal: false,
            recordTitle: "",
            editManageModal: false,
            editManageTitle: "",
            editModuleModal: false,
            productModal: false,
            batchModal: false,
            productList: [],
            batchList: [],
            deleteModal: false,
            delete_id: "",
            delete_key: "",
            moduleList: [],
            nodeList: [],
            // selection
            del_id: "",
            delData: [],
            del_value: false,
            node_index: "",
        };
    },
    mounted() {
        this.getList();
        this.getProductSelect();
        this.getBatchSelect();
        // 模块下拉
        this.getModuleSelect();
    },
    methods: {
        // 模块下拉
        getModuleSelect(){
            module_select().then(res => {
                this.moduleList = res.data;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        handleDragDrop(index, newIndex){
            var id = this.dataModule[index].id;
            var data = {
                example_module_id: id,
                sort: newIndex*1 + 1,
            }
            // 修改序号
            example_module_sort(data).then(res => {
                this.getExampleModuleList();
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getExampleNodeSort(){
            example_node_sort({module_id : this.module_id}).then(res => {
                this.formNode.sort = res.data + 1;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 获取当前时间
        getCurrentTime() {
            return new Date();
        },
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if (this.imgtype == 0 && this.srctype == 1) {
                for (var i = 0; i < param1.length; i++) {
                    this.show_imgs.push(param1[i]);
                }
                for (var i = 0; i < param2.length; i++) {
                    this.imgs.push(param2[i]);
                }
                this.$Message.destroy();
            } else if(this.srctype == 2) {
                for (var i = 0; i < param1.length; i++) {
                    this.show_video =  param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                   this.formNode.video = param2[i];
                }
                this.$Message.destroy();
            }
        },
        openModal(e, index) {
            this.imgtype = e;
            this.srctype = index;
            this.switch_modal = true;
            if(this.srctype == 2){ 
                this.select_type = 'video';
            }else{ 
                this.select_type = 'image';
            }
        },
        getList() {
            example_list(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
                // 删除后，page--
                if(!res.data.data.length && this.storePrams.page != 1){
                    this.storePrams.page --;
                    this.getList();
                }
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        changePageManage(index) {
            this.pageManage.page = index;
            this.getModuleList();
        },
        changePageNode(index) {
            this.pageNode.page = index;
            this.getExampleNodeList();
        },
        changePageProduct(index) {
            this.pageProduct.page = index;
            this.getExampleProductList();
        },
        changePageBatch(index) {
            this.pageBatch.page = index;
            this.getExampleBatchList();
        },
        changeModuleTime(e){
            if(e){
                this.formModule.node_time = e;
            }else {
                this.formModule.node_time = '';
            }
        },
        changeNodeTime(e){
            if(e){
                this.formNode.node_time = e;
            }else {
                this.formNode.node_time = '';
            }
        },
        getProductSelect(){
            product_select().then((res) => {
                this.productList = res.data;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getBatchSelect(){
            batch_select().then((res) => {
                this.batchList = res.data;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 模块管理列表
        getModuleList(){
            module_list(this.pageManage).then((res) => {
                this.dataManage = res.data.data;
                this.totalManage = res.data.total;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 记录模块列表
        getExampleModuleList(){
            this.pageModule.example_id = this.example_id;
            example_module_list(this.pageModule).then((res) => {
                this.dataModule = res.data;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 节点列表
        getExampleNodeList(){
            this.pageNode.example_module_id = this.example_module_id;
            example_node_list(this.pageNode).then((res) => {
                this.dataNode = res.data.data;
                this.totalNode = res.data.total;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 关联产品列表
        getExampleProductList(){
            this.pageProduct.example_id = this.example_id;
            example_product_list(this.pageProduct).then((res) => {
                this.dataProduct = res.data.data;
                this.totalProduct = res.data.total;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 关联批次列表
        getExampleBatchList(){
            this.pageBatch.example_id = this.example_id;
            example_batch_list(this.pageBatch).then((res) => {
                this.dataBatch = res.data.data;
                this.totalBatch = res.data.total;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        goDelete(row){
            this.delete_id = row.id;
            this.delete_key = row.name;
            this.deleteModal = true;
        },
        goDel(index, row){
            if(index == 0 && this.delData.length == 0){
                this.$Message.error('请选择');
                return
            }
            this.$Modal.confirm({
                title: '删除提示',
                content: '确认删除吗？一经删除无法复原',
                onOk: () => {
                    if(index == 0){
                        var del_id = [];
                        this.delData.forEach(item => {
                            del_id.push(item.id)
                        });
                        this.del_id = del_id.join(',');
                        example_delete({ id: this.del_id }).then(res=>{
                            this.getList();
                            this.del_value = false;
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }else if(index == 1){
                        example_delete({ id: row.id }).then(res=>{
                            this.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }else if(index == 2){
                        example_module_delete({ example_module_id: row.id }).then(res=>{
                            this.getExampleModuleList();
                            this.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }else if(index == 3){
                        if(this.node_index == 1){
                            module_node_del({ id: row.id }).then(res=>{
                                this.getModuleNode();
                                this.getModuleList();
                                this.$Message.success(res.msg);
                            }).catch(res=>{
                                this.$Message.error(res.msg);
                            })
                        }else{
                            example_node_delete({ example_node_id: row.id }).then(res=>{
                                this.getExampleNodeList();
                                this.getExampleModuleList();
                                this.$Message.success(res.msg);
                            }).catch(res=>{
                                this.$Message.error(res.msg);
                            })
                        }
                    }else if(index == 4){
                        example_product_delete({ id: row.id }).then(res=>{
                            this.getExampleProductList();
                            this.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }else if(index == 5){
                        example_batch_delete({ id: row.id }).then(res=>{
                            this.getExampleBatchList();
                            this.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }
                },
                onCancel: () => {
                }
            }); 
        },
        // 模块管理
        goManage(){
            this.pageManage.page = 1;
            this.pageManage.keywords = "";
            this.dataManage = [];
            this.getModuleList();
            setTimeout(() => {
                this.manageModal = true;
            }, 300);
        },
        // 记录模块
        goModule(row){
            this.example_id = row.id;
            this.pageModule.keywords = "";
            this.dataModule = [];
            this.getExampleModuleList();
            setTimeout(() => {
                this.moduleModal = true;
            }, 300);
        },
        goNode(i, row){
            // 1：模块管理的节点弹框，2：记录模块的节点弹框
            this.node_index = i;
            if(i == 1){
                this.columnNode = [
                    { type: 'index', width: 60, align: 'center' },
                    { title: "节点名称", key: "name", align: "center" },
                    { title: "操作", slot: "operate", align: "center", width: "200px" },
                ];
                this.formNodeManage.module_id = row.id;
                this.getModuleNode();
            }else{
                this.example_module_id = row.id;
                this.module_id = row.module_id;
                this.getExampleNodeList();
                this.getModuleNodeSelect(row.module_id);
            }
            setTimeout(() => {
                this.nodeModal = true;
            }, 300);
        },
        getModuleNode(){
            module_node({module_id: this.formNodeManage.module_id}).then( res => {
                this.dataNode = res.data.data;
                this.totalNode = res.data.total;
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
        // 关联绑定
        goBind(row){
            this.menuID = "1";
            this.example_id = row.id;
            this.getExampleProductList();
            this.getExampleBatchList();
            setTimeout(() => {
                this.bindModal = true;
            }, 300);
        },
        goRecord(row){
            if(row.id){
                // 编辑记录
                this.recordTitle = '编辑记录';
                this.formRecord.id = row.id;
                this.formRecord.name = row.name;
                this.formRecord.remarks = row.remarks;
            }else{
                // 新增记录
                this.recordTitle = '新增记录';
                this.formRecord.id = "";
                this.formRecord.name = "";
                this.formRecord.remarks = "";
            }
            setTimeout(() => {
                this.recordModal = true;
            }, 300);
        },
        cancelRecordModal(){
            this.recordModal = false;
        },
        // 确定
        submitRecordModal(){
            example_save(this.formRecord).then( res => {
                this.getList();
                this.recordModal = false;
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
        // 新增模块/编辑模块
        goEditManage(row){
            if(row.id){
                this.editManageTitle = "编辑模块";
                this.module_id = row.id;
                this.formManage.id = row.id;
                this.formManage.name = row.name;
                this.goModuleNodeSelectManage();
            }else{
                this.editManageTitle = "新增模块";
                this.formManage.id = "";
                this.formManage.name = "";
                this.formManage.node = [];
            }
            setTimeout(() => {
                this.editManageModal = true;
            }, 300);
        },
        goModuleNodeSelectManage(){
            module_node_select({module_id: this.formManage.id}).then( res => {
                this.formManage.node = res.data;
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
        cancelEditManageModal(){
            this.editManageModal = false;
        },
        submitEditManageModal(){
            module_save(this.formManage).then( res => {
                this.editManageModal = false;
                this.getModuleList();
                // 模块下拉
                this.getModuleSelect();
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
        // 新增记录模块
        goEditModule(){
            this.formModule.example_node_id = "";
            this.formModule.module_id = "";
            this.formModule.content = "";
            this.formModule.imgs = "";
            this.formModule.video = "";
            this.formModule.address = "";
            this.formModule.node_time = "";
            this.formModule.sort = "";
            this.formModule.node_id = "";
            setTimeout(() => {
                this.editModuleModal = true;
            }, 300);
        },
        cancelEditModuleModal(){
            this.editModuleModal = false;
        },
        submitEditModuleModal(){
            this.formModule.example_id = this.example_id;
            example_node_save(this.formModule).then( res => {
                this.editModuleModal = false;
                this.moduleModal = true;
                this.getExampleModuleList();
                this.getList();
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
        // 新增关联产品
        goProduct(){
            this.formProduct.product_id = "";
            setTimeout(() => {
                this.productModal = true;
            }, 300);
        },
        cancelProductModal(){
            this.productModal = false;
        },
        submitProductModal(){
            this.formProduct.example_id = this.example_id;
            example_product_save(this.formProduct).then( res => {
                this.getExampleProductList();
                this.getList();
                this.productModal = false;
                this.bindModal = true;
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
        // 新增关联批次
        goBatch(){
            this.formBatch.batch_id = "";
            setTimeout(() => {
                this.batchModal = true;
            }, 300);
        },
        cancelBatchModal(){
            this.batchModal = false;
        },
        submitBatchModal(){
            this.formBatch.example_id = this.example_id;
            example_batch_save(this.formBatch).then( res => {
                this.getExampleBatchList();
                this.getList();
                this.batchModal = false;
                this.bindModal = true;
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
        goEditNode(row){
            if(this.node_index == 1){
                if(row.id){
                    // 编辑节点
                    this.editNodeTitle = '编辑节点';
                    this.formNodeManage.name = row.name;
                    this.formNodeManage.id = row.id;
                }else{
                    // 新增节点
                    this.editNodeTitle = '新增节点';
                    this.formNodeManage.name = "";
                    this.formNodeManage.id = "";
                }
                setTimeout(() => {
                    this.editNodeManageModal = true;
                }, 300);
            }else{
                if(row.id){
                    // 编辑节点
                    this.editNodeTitle = '编辑节点';
                    this.edit_node_value = true;
                    example_node_info({ example_node_id: row.id }).then(res=>{
                        this.formNode.example_node_id = res.data.id;
                        this.formNode.content = res.data.content;
                        this.formNode.imgs = res.data.imgs;
                        this.formNode.video = res.data.video;
                        this.formNode.address = res.data.address;
                        this.formNode.node_time = res.data.node_time;
                        this.formNode.sort = res.data.sort;
                        this.formNode.node_id = res.data.node_id;
                        this.formNode.module_id = res.data.module_id;
                        if(res.data.imgs){
                            this.imgs = res.data.imgs.split(',');
                        }
                        this.show_imgs = res.data.show_imgs;
                        this.show_video = res.data.show_video;
                    }).catch(res=>{
                        this.$Message.error(res.msg);
                    })
                }else{
                    // 新增节点
                    this.editNodeTitle = '新增节点';
                    this.edit_node_value = false;
                    this.formNode.example_node_id = "";
                    this.formNode.content = "";
                    this.formNode.imgs = "";
                    this.formNode.video = "";
                    this.formNode.address = "";
                    this.formNode.node_time = this.getCurrentTime();
                    this.formNode.node_id = "";
                    this.imgs = [];
                    this.show_imgs = [];
                    this.show_video = '';
                    this.getExampleNodeSort();
                }
                setTimeout(() => {
                    this.editNodeModal = true;
                }, 300);
            }
        },
        cancelEditNodeManageModal(){
            this.editNodeManageModal = false;
        },
        cancelEditNodeModal(){
            this.editNodeModal = false;
        },
        submitEditNodeModal(){
            if(this.node_index == 1){
                module_node_save(this.formNodeManage).then( res => {
                    this.editNodeManageModal = false;
                    this.nodeModal = true;
                    this.getModuleNode();
                    this.getModuleList();
                    this.$Message.success(res.msg);
                }).catch(res=>{
                    this.$Message.error(res.msg);
                })
            }else{
                this.formNode.example_id = this.example_id;
                this.formNode.module_id = this.module_id;
                this.formNode.imgs = this.imgs.join(',');
                example_node_save(this.formNode).then( res => {
                    this.editNodeModal = false;
                    this.nodeModal = true;
                    this.getExampleNodeList();
                    this.getExampleModuleList();
                    this.$Message.success(res.msg);
                }).catch(res=>{
                    this.$Message.error(res.msg);
                })
            }
        },
        cancelDeleteModal(){
            this.deleteModal = false;
        },
        submitDeleteModal(){
            module_del({ id: this.delete_id }).then(res=>{
                this.deleteModal = false;
                this.getModuleList();
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
        selectMenu(name) {
            this.menuID = name;
        },
        delImg(index){
            this.imgs.splice(index, 1);
            this.show_imgs.splice(index, 1);
        },
        // 移动时
        onStart(e) {
            this.drag = true;
            console.log("触发移动", e);
        },
        // 移动结束
        onEnd(e) {
            this.drag = false;
            console.log("移动结束", e);
        },
        // selection
        changeSelection(e){
            this.delData = e;
            if(this.dataTable.length === e.length){
                this.del_value = true;
            }else{
                this.del_value = false;
            }
        },
        handleSelectAll(e){
            if(e == true){
                this.delData = this.dataTable;
                this.$refs.selection.selectAll(true);
            }else{
                this.$refs.selection.selectAll(false);
            }
        },
        deleteManage(item, index){
            if(item.id){
                this.goModuleNodeDel(item);
            }else{
                this.formManage.node.splice(index, 1);
            }
        },
        addManage(){
            this.formManage.node.push({id: "", name: ""});
        },
        goModuleNodeDel(item){
            module_node_del({id: item.id}).then( res => {
                this.goModuleNodeSelectManage();
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
        goSearch(index){
            if(index == 1){
                this.pageManage.page = 1;
                this.dataManage = [];
                this.getModuleList();
            }else if(index == 2){
                this.dataModule = [];
                this.getExampleModuleList();
            }
        },
        changeModule(event){
            if(event){
                this.getModuleNodeSelect(event);
            }
        },
        getModuleNodeSelect(id){
            module_node_select({module_id: id}).then( res => {
                this.nodeList = res.data;
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
    },
};
</script>

<style scoped>
.container {
    padding: 24px;
    background: #FFFFFF;
    box-shadow: 0px 0px 4px 0px rgba(82,102,136,0.1);
    border-radius: 4px;
}
.upload-container {
    width: 70px;
    height: 70px;
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px dashed #9FA5BB;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.wh100 {
    width: 100%;
    height: 100%;
}
::v-deep .ivu-menu.ivu-menu-light.ivu-menu-horizontal{
    display: flex;
    align-items: center;
    justify-content: space-around;
}
::v-deep .ivu-menu-item {
    font-size: 16px;
}
::v-deep .ivu-menu-item:hover {
    font-size: 16px;
    color: #FF761D  !important;
    border-bottom: 2px solid #FF761D  !important;
}
::v-deep .ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected {
    color: #FF761D ;
    font-size: 16px;
    border-bottom: 2px solid #FF761D  !important;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #FF761D ;
    background-color: #FF761D ;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.picture-container {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
}
.dragg-container {
    display: flex;
    flex-wrap: wrap;
}
.position-r {
    position: relative;
}
.upload-icon {
    position: absolute;
    top: -10px;
    right: -10px;
}
.width_100 {
    width: 100%;
}
.ta-r {
    text-align: right;
}
.manage-container {
    display: flex;
    align-items: center;
    margin: 12px 0 0 24px;
}
.manage-delete {
    margin-left: 12px;
    width: 22px;
    height: 22px;
    cursor: pointer;
}
.delete-modal-title {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #484E66;
}
.delete-modal-container {
    margin: 24px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #484E66;
}
.delete-modal-footer {
    margin-top: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #FF761D;
}
.module-tip {
    margin-left: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #9FA5BB;
}
.icon-sort {
    width: 18px;
    height: 18px;
    cursor: pointer;
}
.page-container {
    margin-top: 24px;
    text-align: right;
}
.page-checkbox-container {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
</style>